export interface GetResponseInterface {
    meta: {
        count: number;
        next: null | string;
        previous: null | string;
    };
    results: Array<{ [prop: string]: any }>;
}

export const defaultGetResponse = {
    meta: {
        count: 0,
        next: null,
        previous: null
    },
    results: []
};
